import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export default styled(Flexer.Parent).attrs(() => ({
  flexDirection: 'column',
}))`
  flex: 1;
  overflow: hidden;
`;
